// extracted by mini-css-extract-plugin
export default {"font-renta":"QuestionPicturesPage_font-renta__bWf4w","picture":"QuestionPicturesPage_picture__X2bFl","pictureLabel":"QuestionPicturesPage_pictureLabel__1QzfF"};